import { Button } from 'antd';
import { IoSearchSharp } from 'react-icons/io5';
import { IBibleTranslation, IChapter } from 'types';

interface SearchButtonsRowProps {
  chapters: IChapter[];
  translationIds: number[];
  bibleTranslations: IBibleTranslation[];
  onSearchClick: (translationId: number) => void;
  notesShown?: boolean;
}

function SearchButtonsRow({
  chapters,
  translationIds,
  bibleTranslations,
  onSearchClick,
  notesShown = false,
}: SearchButtonsRowProps) {
  return (
    <div className="bible-v2-viewer-content__search-buttons-row">
      {chapters.map((chapterData, columnIndex) => {
        const translationId = translationIds[columnIndex];
        const translation = bibleTranslations.find(t => t.id === translationId);
        const translationName = translation
          ? `${translation.name} ${translation.translator_name}`.trim()
          : 'Search';

        return (
          <div key={chapterData.id} className="bible-v2-viewer-content__search-button-cell">
            <Button
              className="bible-v2-viewer-content__header-search-button"
              icon={<IoSearchSharp />}
              onClick={() => onSearchClick(translationId)}
            >
              {translationName}
            </Button>
          </div>
        );
      })}
      {notesShown && (
        <div className="bible-v2-viewer-content__search-button-cell bible-v2-viewer-content__search-button-cell--notes">
          {/* Notes column has no search button */}
        </div>
      )}
    </div>
  );
}

export default SearchButtonsRow;
